var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 185,
    viewBox: "0 0 300 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1922_6610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.343 20.5847L278.177 114.013L183.657 168.948L21.8228 75.5193L116.343 20.5847Z",
    fill: "#3785C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1688 84.9514L116.364 37.3085L263.352 122.638L278.177 114.013L116.343 20.5847L21.8228 75.5193L38.1688 84.9514Z",
    fill: "#0073BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5056 89.2846L202.574 162.548L207.043 159.967L80.9751 86.7036L76.5056 89.2846Z",
    fill: "#0059A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.388 64.2721L241.456 137.536L245.936 134.955L119.868 61.6912L115.388 64.2721Z",
    fill: "#0059A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.364 15.5488L116.343 20.5849L17.4688 78.048L17.4792 73.0119L116.364 15.5488Z",
    fill: "#F9C554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.531 111.485L282.521 116.521L116.343 20.5849L116.364 15.5488L282.531 111.485Z",
    fill: "#F9C554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.71 179.073L183.699 184.109L0 78.048L0.0104917 73.012L183.71 179.073Z",
    fill: "#F9C554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 111.485L299.989 116.521L183.699 184.109L183.71 179.073L300 111.485Z",
    fill: "#F9C554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.301 5.43481L300 111.496L183.71 179.073L0.010498 73.0119L116.301 5.43481ZM183.647 168.959L282.521 111.496L116.364 15.5488L17.4792 73.0119L183.647 168.948V168.959Z",
    fill: "#FBE18F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.452 26.2504L151.28 24.9809C151.154 24.9075 151.06 24.7396 151.06 24.4668C151.049 20.4485 151.039 16.4302 151.028 12.4119L153.2 13.6814C153.21 17.6997 153.221 21.718 153.231 25.7363C153.231 26.0091 153.315 26.177 153.452 26.2504Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.452 26.2504L151.28 24.9809C151.154 24.9075 151.06 24.7396 151.06 24.4668C151.049 20.4485 151.039 16.4302 151.028 12.4119L153.2 13.6814C153.21 17.6997 153.221 21.718 153.231 25.7363C153.231 26.0091 153.315 26.177 153.452 26.2504Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.434 8.6766L154.616 9.9461C154.459 9.85167 154.228 9.87266 154.008 10.009L151.836 8.75004C152.067 8.61365 152.287 8.59267 152.445 8.68709L152.434 8.6766Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.997 9.99871L151.826 8.73971C151.826 8.73971 151.899 8.69774 151.941 8.67676L154.113 9.93576C154.113 9.93576 154.039 9.97773 153.997 9.99871Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.113 9.94624L151.941 8.68723C151.941 8.68723 152.004 8.65576 152.046 8.64526L154.218 9.91476C154.218 9.91476 154.155 9.93574 154.113 9.94624V9.94624Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.218 9.91475L152.046 8.64525C152.046 8.64525 152.098 8.63476 152.119 8.62427L154.302 9.89376C154.302 9.89376 154.249 9.89376 154.228 9.90426L154.218 9.91475Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.302 9.89376L152.119 8.62427C152.119 8.62427 152.161 8.62427 152.182 8.62427L154.365 9.89376C154.365 9.89376 154.323 9.89376 154.302 9.89376Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.365 9.88327L152.182 8.61377C152.182 8.61377 152.224 8.61377 152.245 8.61377L154.417 9.88327C154.417 9.88327 154.375 9.88327 154.365 9.88327V9.88327Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.417 9.88327L152.245 8.61377C152.245 8.61377 152.277 8.61377 152.298 8.61377L154.48 9.88327C154.48 9.88327 154.438 9.88327 154.428 9.88327H154.417Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.47 9.89376L152.287 8.62427L154.511 9.90426H154.47V9.89376Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.522 9.90426L152.34 8.63477L154.564 9.91475H154.522V9.90426Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.564 9.92526L152.382 8.65576L154.595 9.94624L154.553 9.92526H154.564Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.606 9.94625L152.434 8.67676L154.616 9.94625H154.606Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.67 58.9216L139.498 57.6626C139.361 57.5891 139.277 57.4213 139.277 57.1485C139.256 48.6292 139.235 40.11 139.204 31.5802C139.204 28.9573 142.058 25.2957 143.548 22.7147C146.129 18.2557 148.699 13.7968 151.269 9.33777C151.427 9.0545 151.637 8.85515 151.836 8.73975L154.008 9.99875C153.808 10.1142 153.609 10.3135 153.441 10.5968C150.86 15.0558 148.29 19.5042 145.719 23.9737C144.23 26.5547 141.376 30.2163 141.376 32.8392C141.397 41.3585 141.418 49.8882 141.449 58.4075C141.449 58.6803 141.533 58.8482 141.67 58.9216V58.9216Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.67 58.9216L139.498 57.6626C139.361 57.5892 139.277 57.4213 139.277 57.1485C139.256 48.6293 139.235 40.11 139.204 31.5802C139.204 31.4124 139.204 31.234 139.235 31.0557L141.407 32.3252C141.386 32.5035 141.376 32.6819 141.376 32.8497C141.397 41.369 141.418 49.8988 141.449 58.418C141.449 58.6908 141.533 58.8587 141.67 58.9321V58.9216Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.407 32.3146L139.235 31.0451C139.256 30.9088 139.277 30.7619 139.309 30.615L141.481 31.8845C141.449 32.0314 141.428 32.1783 141.407 32.3146Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.481 31.8845L139.309 30.615C139.33 30.4891 139.361 30.3632 139.403 30.2268L141.586 31.4963C141.544 31.6222 141.512 31.7586 141.491 31.8845H141.481Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.575 31.4963L139.393 30.2268C139.424 30.1009 139.466 29.975 139.508 29.8491L141.68 31.1081C141.638 31.234 141.596 31.3599 141.565 31.4858L141.575 31.4963Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.691 31.1186L139.519 29.8596C139.561 29.7232 139.613 29.5973 139.666 29.4609L141.848 30.7199C141.795 30.8563 141.743 30.9927 141.701 31.1186H141.691Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.837 30.7094L139.655 29.4504C139.708 29.3035 139.771 29.1566 139.834 29.0098L142.005 30.2793C141.942 30.4261 141.879 30.5835 141.827 30.7199L141.837 30.7094Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.026 30.2687L139.854 28.9992C139.928 28.8208 140.012 28.653 140.096 28.4746L142.278 29.7441C142.194 29.9225 142.11 30.0903 142.037 30.2687H142.026Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.257 29.7442L140.075 28.4747C140.18 28.2544 140.295 28.0445 140.411 27.8242L142.582 29.0937C142.467 29.314 142.352 29.5344 142.247 29.7442H142.257Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.593 29.0937L140.421 27.8242C140.578 27.5304 140.746 27.2261 140.925 26.9324L143.096 28.2019C142.918 28.4956 142.75 28.7999 142.593 29.0937Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.096 28.2018L140.925 26.9323C141.774 25.4635 142.782 24.0156 143.495 22.7986L145.677 24.0681C144.964 25.2851 143.967 26.7435 143.107 28.2018H143.096Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.656 24.0681L143.474 22.7986C143.474 22.7986 143.516 22.7356 143.527 22.7041C146.108 18.2452 148.678 13.7862 151.248 9.32721C151.248 9.31672 153.431 10.5757 153.431 10.5757C150.85 15.0452 148.279 19.5042 145.698 23.9632C145.677 23.9946 145.667 24.0261 145.646 24.0576L145.656 24.0681Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.441 10.5863L151.269 9.31685C151.269 9.31685 151.301 9.27488 151.311 9.24341L153.483 10.5129C153.483 10.5129 153.452 10.5549 153.441 10.5863Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.483 10.5129L151.311 9.24336C151.311 9.24336 151.343 9.2014 151.353 9.16992L153.536 10.4394C153.536 10.4394 153.504 10.4814 153.494 10.5129H153.483Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.536 10.4499L151.353 9.18038C151.353 9.18038 151.385 9.12792 151.406 9.10693L153.578 10.3659C153.578 10.3659 153.546 10.4184 153.525 10.4394L153.536 10.4499Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.588 10.3764L151.416 9.11739C151.416 9.11739 151.458 9.06493 151.479 9.04395L153.651 10.3134C153.651 10.3134 153.609 10.3659 153.588 10.3869V10.3764Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.651 10.3029L151.479 9.03339C151.479 9.03339 151.532 8.97044 151.563 8.93896L153.745 10.2085C153.745 10.2085 153.693 10.2714 153.662 10.3029H153.651Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.735 10.2086L151.553 8.93908C151.637 8.85515 151.731 8.78171 151.815 8.72925L153.987 9.98825C153.892 10.0407 153.808 10.1142 153.725 10.1981L153.735 10.2086Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.997 9.99857C154.427 9.75726 154.837 9.89366 154.837 10.4497C154.847 15.2234 154.858 20.0077 154.879 24.7814C154.879 25.3899 154.469 25.9355 154.06 26.1663C153.651 26.4076 153.242 26.3342 153.231 25.7256C153.221 21.7073 153.21 17.689 153.2 13.6707C151.185 17.1539 149.182 20.6267 147.178 24.1099C145.866 26.3761 144.555 28.6423 143.254 30.9086C143.149 31.0869 143.075 31.2233 143.023 31.3177C143.023 31.6535 143.023 31.9892 143.023 32.3144C143.044 40.6868 143.065 49.0592 143.096 57.4316C143.096 58.0401 142.687 58.5857 142.278 58.8165C141.869 59.0578 141.449 58.9844 141.449 58.3759C141.428 49.8566 141.397 41.3373 141.376 32.8076C141.376 30.1846 144.229 26.523 145.719 23.9421C148.29 19.4831 150.86 15.0241 153.441 10.5651C153.599 10.2818 153.808 10.0825 154.008 9.9671L153.997 9.99857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.005 17.6367L136.833 16.3672C136.707 16.2937 136.613 16.1259 136.613 15.8531C136.602 11.8347 136.592 7.81642 136.581 3.7981L138.763 5.0571C138.774 9.07543 138.784 13.0938 138.795 17.1121C138.795 17.3849 138.879 17.5527 139.005 17.6262V17.6367Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.005 17.6367L136.833 16.3672C136.707 16.2937 136.613 16.1259 136.613 15.8531C136.602 11.8347 136.592 7.81642 136.581 3.7981L138.763 5.0571C138.774 9.07543 138.784 13.0938 138.795 17.1121C138.795 17.3849 138.879 17.5527 139.005 17.6262V17.6367Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.987 0.0524617L140.169 1.32196C140.012 1.22753 139.781 1.24852 139.561 1.38491L137.389 0.115412C137.609 -0.0104885 137.84 -0.0419637 137.998 0.0524617H137.987Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.55 1.38494L137.379 0.115441C137.379 0.115441 137.462 0.0734737 137.494 0.0524902L139.666 1.32199C139.666 1.32199 139.592 1.35346 139.55 1.38494Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.666 1.32197L137.494 0.0524712C137.494 0.0524712 137.557 0.0314878 137.588 0.0209961L139.76 1.29049C139.76 1.29049 139.697 1.31148 139.655 1.32197H139.666Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.771 1.29048L137.599 0.0209834C137.599 0.0209834 137.651 0.0104917 137.672 0L139.844 1.25901C139.844 1.25901 139.792 1.2695 139.771 1.27999V1.29048Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.844 1.2695L137.672 0C137.672 0 137.714 0 137.735 0L139.907 1.25901C139.907 1.25901 139.865 1.25901 139.844 1.25901V1.2695Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.918 1.2695L137.735 0C137.735 0 137.777 0 137.788 0L139.97 1.25901C139.97 1.25901 139.928 1.25901 139.907 1.25901L139.918 1.2695Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.97 1.2695L137.798 0C137.798 0 137.83 0 137.851 0L140.022 1.25901H139.97V1.2695Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.022 1.2695L137.851 0L140.075 1.2695H140.022V1.2695Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.075 1.28L137.893 0.0209961L140.117 1.30098H140.075V1.28Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.117 1.30099L137.935 0.0314941L140.148 1.32197L140.106 1.30099H140.117Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.159 1.32199L137.987 0.0524902L140.169 1.32199H140.159Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.212 50.2973L125.04 49.0278C124.914 48.9544 124.83 48.7865 124.82 48.5137C124.799 39.9945 124.778 31.4752 124.746 22.9454C124.746 20.3225 127.6 16.6609 129.09 14.0799C131.66 9.62096 134.231 5.16199 136.812 0.703008C136.969 0.419732 137.179 0.220389 137.378 0.10498L139.55 1.37448C139.351 1.48989 139.152 1.68923 138.984 1.97251C136.403 6.43148 133.832 10.8905 131.262 15.3494C129.772 17.9304 126.918 21.592 126.918 24.2149C126.939 32.7342 126.971 41.264 126.992 49.7832C126.992 50.056 127.076 50.2239 127.212 50.2973V50.2973Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.212 50.2974L125.04 49.0279C124.914 48.9544 124.83 48.7866 124.82 48.5138C124.799 39.9945 124.778 31.4752 124.746 22.9455C124.746 22.7776 124.757 22.5993 124.778 22.4209L126.95 23.6904C126.929 23.8688 126.918 24.0471 126.918 24.215C126.939 32.7342 126.971 41.264 126.992 49.7833C126.992 50.0561 127.076 50.2239 127.212 50.2974Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.96 23.6904L124.788 22.4209C124.809 22.2845 124.83 22.1376 124.862 21.9907L127.044 23.2602C127.013 23.4071 126.992 23.554 126.971 23.6904H126.96Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.034 23.2602L124.851 21.9907C124.872 21.8648 124.914 21.7389 124.946 21.613L127.118 22.872C127.086 22.9979 127.055 23.1343 127.023 23.2602H127.034Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.128 22.8721L124.956 21.6131C124.988 21.4872 125.03 21.3613 125.072 21.2354L127.254 22.5048C127.212 22.6307 127.17 22.7566 127.139 22.8825L127.128 22.8721Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.243 22.4944L125.061 21.2249C125.103 21.0885 125.156 20.9626 125.208 20.8262L127.39 22.0957C127.338 22.2321 127.285 22.358 127.243 22.4944Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.39 22.0956L125.208 20.8261C125.261 20.6793 125.324 20.5324 125.386 20.3855L127.569 21.655C127.506 21.8019 127.443 21.9593 127.39 22.0956Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.579 21.6444L125.397 20.3749C125.47 20.1966 125.554 20.0287 125.638 19.8503L127.821 21.1198C127.737 21.2982 127.653 21.4661 127.579 21.6444Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.81 21.1304L125.628 19.8609C125.733 19.6406 125.848 19.4308 125.964 19.2104L128.135 20.4799C128.02 20.7003 127.905 20.9206 127.8 21.1304H127.81Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.146 20.4694L125.974 19.1999C126.131 18.9061 126.299 18.6019 126.478 18.3081L128.649 19.5776C128.471 19.8714 128.303 20.1756 128.146 20.4694Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.649 19.5775L126.478 18.3081C127.338 16.8392 128.335 15.3914 129.048 14.1743L131.23 15.4438C130.517 16.6609 129.52 18.1192 128.66 19.5775H128.649Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.209 15.4438L129.027 14.1743C129.027 14.1743 129.059 14.1114 129.08 14.0799C131.65 9.6209 134.22 5.16192 136.801 0.702946C136.801 0.692454 138.984 1.95146 138.984 1.95146C136.403 6.42093 133.832 10.8799 131.251 15.3389C131.23 15.3704 131.209 15.4018 131.199 15.4333L131.209 15.4438Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.994 1.96208L136.812 0.692583C136.812 0.692583 136.843 0.640124 136.854 0.619141L139.036 1.88864C139.036 1.88864 139.005 1.9306 138.994 1.96208Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.036 1.89909L136.854 0.629594C136.854 0.629594 136.885 0.577136 136.906 0.556152L139.089 1.81516C139.089 1.81516 139.057 1.85712 139.036 1.8886V1.89909Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.089 1.82561L136.906 0.566606C136.906 0.566606 136.938 0.514147 136.959 0.493164L139.141 1.76266C139.141 1.76266 139.11 1.81512 139.089 1.8361V1.82561Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.141 1.75212L136.959 0.482622C136.959 0.482622 137.001 0.430163 137.022 0.40918L139.194 1.67868C139.194 1.67868 139.152 1.73114 139.131 1.75212H139.141Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.204 1.67862L137.032 0.409123C137.032 0.409123 137.085 0.346172 137.116 0.314697L139.288 1.58419C139.288 1.58419 139.235 1.63665 139.204 1.67862V1.67862Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.288 1.58431L137.116 0.314815C137.2 0.230881 137.295 0.157439 137.379 0.10498L139.55 1.37448C139.456 1.42694 139.372 1.50038 139.288 1.58431Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.55 1.3848C139.97 1.14349 140.39 1.27989 140.39 1.83595C140.4 6.60968 140.421 11.3939 140.432 16.1676C140.432 16.7761 140.022 17.3217 139.613 17.5525C139.204 17.7938 138.795 17.7204 138.784 17.1119C138.774 13.0936 138.763 9.07523 138.753 5.0569C136.738 8.54015 134.735 12.0234 132.72 15.4962C131.409 17.7624 130.108 20.0286 128.796 22.2948C128.691 22.4731 128.618 22.6095 128.555 22.704C128.555 23.0397 128.555 23.3754 128.555 23.7007C128.576 32.0731 128.607 40.4454 128.628 48.8178C128.628 49.4263 128.219 49.9719 127.81 50.2027C127.401 50.444 126.981 50.3706 126.981 49.7621C126.96 41.2428 126.939 32.7235 126.908 24.1938C126.908 21.5709 129.761 17.9092 131.251 15.3283C133.822 10.8693 136.392 6.41033 138.973 1.95135C139.131 1.66808 139.34 1.46874 139.54 1.35333L139.55 1.3848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.712 33.4057L139.204 40.5086L139.215 36.9624L125.712 30.0063V33.4057Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.712 45.7543L139.204 52.8677L139.215 49.311L125.712 42.3655V45.7543Z",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.71 39.2495L152.245 58.1346L151.028 67.2729L119.71 47.6324V39.2495Z",
    fill: "#3785C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.8228 75.5193C21.8228 75.5193 241.33 137.336 278.177 114.024L116.343 20.5847L21.8228 75.5193Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1922_6610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 184.109,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPool);
export default __webpack_public_path__ + "static/media/Pool.a9592034059d1d50ad917b209460397a.svg";
export { ForwardRef as ReactComponent };